import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import { CpLogoWithHeader } from './variants/logo-section-with-header';
import { CpLogoWithoutHeader } from './variants/logo-section-without-header';

export interface CpLogoWidgetRendererData extends Record<string, unknown> {
  title: string;
  description: string;
  collaborationIconConfig: Record<string, unknown>;
  vendorLogo: any;
  customerLogo: string;
}

export interface CpLogoWidgetRendererProps extends CpWidgetProps {
  data: CpLogoWidgetRendererData;
}

export const CpLogoWidget: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
  onRuntimeConfigChange,
  runtimeConfig,
}) => {
  const widgetData = useMemo(() => data as CpLogoWidgetRendererData, [data]);

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.LogoWithHeader:
    case undefined:
      return (
        <CpLogoWithHeader
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.LogoWithoutHeader:
      return (
        <CpLogoWithoutHeader
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    default:
      return <></>;
  }
};
